// extracted by mini-css-extract-plugin
module.exports =  {"form":"ak_g7T"};